<template>
  <div>
    <van-nav-bar
      title="新闻资讯"
      left-text=""
      left-arrow
      @click-left="goBack"
    />

    <div style="padding: 0px 10px">
      <van-row>
          <van-col span="24">
              <p style="text-align:center;">{{ title }}</p>
              <p style="text-align:center; color:grey;"><span style="padding-right:15px">发布者: {{ source }}</span><span> {{ time }}</span></p>
              <div style="color:grey;" v-html="content"></div>
          </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewsInfoDetailed",
  data() {
    return {
      title:"",
      time:"",
      source:"",
      content:""
    };
  },
  methods: {
    goBack(){
      window.history.back();
    },
        getNewsDetails(){
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "news_details",
              id:sessionStorage.getItem("nid")
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
                let resData = res.data;
                that.title = resData.data.title;
                that.time = resData.data.time;
                that.source = resData.data.source;
                let content = resData.data.content;
                that.content = content
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(res.data.msg);
            }
          });
      }
  },
  mounted: function () {
    this.getNewsDetails();
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NewsInfoDetailed.vue